import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54030f40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h6 q-mb-md" }
const _hoisted_2 = {
  key: 0,
  class: "youtube-embed-container"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.resource.title), 1),
    (_ctx.isVideo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("iframe", {
            src: _ctx.resource.src,
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          }, "\n      ", 8, _hoisted_3)
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_4, [
          _createVNode(_component_q_btn, {
            type: "a",
            href: _ctx.resource.src,
            target: "_blank",
            icon: _ctx.resource.icon,
            label: "View",
            flat: ""
          }, null, 8, ["href", "icon"])
        ]))
  ]))
}